import { TechnicalSettings } from "@imi/api-client/index.js";
import { CustomPipeSeries } from "@src/core/api/customPipeSeries";
import { PipeSeriesPreference } from "@src/core/api/pipeSeriesPreference";
import { WaterCharacteristicsPreference } from "@src/core/api/waterCharacteristicsPreferences";
import { isNullish } from "radashi";
import { engine } from "../..";
import { toArray } from "../../vector";
import {
  BatchSuggestionInput,
  GetBatchSuggestionsFilters,
} from "../batchSelectionRepository";
import { initRegulatingValvesSuggestionArgs } from "./initRegulatingValvesSuggestionArgs";
import { initSmartControlValvesSuggestionArgs } from "./initSmartControlValvesSuggestionArgs";

export type BatchSuggestionArgsOptions = {
  categoryId: string;
  customPipeSeries: CustomPipeSeries[];
  filters: GetBatchSuggestionsFilters;
  pipeSeriesPreference: PipeSeriesPreference;
  technicalSettings: TechnicalSettings | null;
  waterCharacteristics: WaterCharacteristicsPreference | null;
};

export function initSuggestionArgs(
  inputs: BatchSuggestionInput[],
  options: BatchSuggestionArgsOptions,
) {
  const { cleanup, suggestionArgs } = initValveSuggestionArgs({
    ...options,
    pipeSeriesPreference: { ...options.pipeSeriesPreference, pipes: null },
  });
  if (!suggestionArgs) {
    return { cleanup, inputsVector: null, suggestionArgs: null };
  }

  const inputsVector = new engine.BatchInputArgsVectorPtr();
  for (const input of inputs) {
    const batchInput = buildInputArgs(input);
    inputsVector.push_back(batchInput);
  }

  return {
    cleanup() {
      cleanup();
      toArray(inputsVector).forEach((input) => input.delete());
    },
    inputsVector,
    suggestionArgs,
  };
}

function buildInputArgs(input: BatchSuggestionInput) {
  const batchInput = new engine.BatchInputArgs();
  if (!isNullish(input.flow)) batchInput.flow = input.flow;
  if (!isNullish(input.dp)) batchInput.dp = input.dp;
  if (!isNullish(input.dpBranch)) batchInput.dpBranch = input.dpBranch;
  if (!isNullish(input.dpMax)) batchInput.dpMax = input.dpMax;
  if (!isNullish(input.kvs)) batchInput.kvs = input.kvs;
  if (!isNullish(input.pipeSize)) batchInput.pipeSize = input.pipeSize;
  return batchInput;
}

function initValveSuggestionArgs(options: BatchSuggestionArgsOptions) {
  switch (options.categoryId) {
    case "TS_REGV_Category":
      return initRegulatingValvesSuggestionArgs(options);
    case "TS_SMRTCV_Category":
      return initSmartControlValvesSuggestionArgs(options);
    default:
      return { cleanup() {}, suggestionArgs: null };
  }
}
